// Dashboard · Maps — synthèse des ventes & avis sur les cartes
// imprimées geoVINUM Maps. Deux cartes qui pointent vers les pages
// de gestion dédiées (Prints/Gelato orders + Avis boutique).
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Image, Star, ArrowRight, Loader2 } from "lucide-react";
import { adminApi } from "@/lib/adminApi";

const AdminDashboardMapsPage = () => {
  const [reviewsCount, setReviewsCount] = useState(null);
  const [pendingReviews, setPendingReviews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [publishedRes, pendingRes] = await Promise.all([
          adminApi.shopReviewsList("published").catch(() => null),
          adminApi.shopReviewsList("pending").catch(() => null),
        ]);
        if (!cancelled) {
          setReviewsCount(publishedRes?.items?.length ?? publishedRes?.total ?? 0);
          setPendingReviews(pendingRes?.items?.length ?? pendingRes?.total ?? 0);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-6" data-testid="admin-dashboard-maps">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-widest text-[color:var(--gv-pink)] mb-1">Dashboard</div>
        <h1 className="font-display text-3xl text-[color:var(--gv-ink)]">Maps geoVINUM</h1>
        <p className="text-[13.5px] text-[color:var(--gv-ink)]/60 mt-1 max-w-2xl">
          Cartes imprimées (Gelato) — ventes & avis clients.
        </p>
      </div>

      {loading ? (
        <div className="min-h-[200px] flex items-center justify-center">
          <Loader2 className="animate-spin text-[color:var(--gv-pink)]" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link
            to="/admin/prints"
            className="group bg-white border border-[color:var(--gv-line)] rounded-[6px] p-6 hover:border-[color:var(--gv-pink)] transition-colors"
            data-testid="dashboard-maps-sales"
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="w-10 h-10 rounded-[5px] bg-[color:var(--gv-pink)]/10 flex items-center justify-center">
                <Image size={20} className="text-[color:var(--gv-pink)]" />
              </div>
              <ArrowRight size={16} className="text-[color:var(--gv-ink)]/30 group-hover:text-[color:var(--gv-pink)] transition-colors" />
            </div>
            <div className="font-display text-lg text-[color:var(--gv-ink)]">Ventes</div>
            <div className="text-[12.5px] text-[color:var(--gv-ink)]/60 mt-1">
              Commandes Prints / Gelato — historique, uploads de fichiers imprimables, suivi des envois.
            </div>
          </Link>

          <Link
            to="/admin/shop/reviews"
            className="group bg-white border border-[color:var(--gv-line)] rounded-[6px] p-6 hover:border-[color:var(--gv-pink)] transition-colors"
            data-testid="dashboard-maps-reviews"
          >
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="w-10 h-10 rounded-[5px] bg-[color:var(--gv-pink)]/10 flex items-center justify-center">
                <Star size={20} className="text-[color:var(--gv-pink)]" />
              </div>
              <ArrowRight size={16} className="text-[color:var(--gv-ink)]/30 group-hover:text-[color:var(--gv-pink)] transition-colors" />
            </div>
            <div className="font-display text-lg text-[color:var(--gv-ink)]">Avis boutique</div>
            <div className="text-[32px] font-display text-[color:var(--gv-ink)] mt-2 leading-none">
              {reviewsCount ?? 0}
              {pendingReviews > 0 && (
                <span className="text-[13px] text-[color:var(--gv-pink)]/80 ml-2 font-mono">· {pendingReviews} en attente</span>
              )}
            </div>
            <div className="text-[12.5px] text-[color:var(--gv-ink)]/60 mt-1">
              Avis publié{(reviewsCount ?? 0) > 1 ? "s" : ""} par les acheteurs des cartes.
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default AdminDashboardMapsPage;
